<template>
    <div class="col-3 col-sm-3">
        <div class="list-group">
            <router-link :to="`/account/users/general-partners/${id}/basic`" :class="[menu === 'basic' ? 'active' : '', 'list-group-item']" v-tooltip="trans('user.basic')"><span class="hidden-sm-up"><i class="fas fa-user"></i></span>
                <span class="hidden-xs-down">
                    {{trans('user.basic')}}
                </span>
            </router-link>

          <router-link :to="`/account/user/${id}/notes`" :class="[menu === 'notes' ? 'active' : '', 'list-group-item']" v-tooltip="'Notes'"><span class="hidden-sm-up"><i class="fas fa-file"></i></span>
            <span class="hidden-xs-down">
                   Notes
                </span>
          </router-link>

          <router-link :to="`/account/user/${id}/emails-pipeline`" :class="[menu === 'emails-pipeline' ? 'active' : '', 'list-group-item']" v-tooltip="'Contact Pipeline'"><span class="hidden-sm-up"><i class="fas fa-mailbox"></i></span>
            <span class="hidden-xs-down">
                   History
                </span>
          </router-link>

          <router-link :to="`/account/user/${id}/questionnaire`" :class="[menu === 'questionnaire' ? 'active' : '', 'list-group-item']" v-tooltip="'Questionnaire'"><span class="hidden-sm-up"><i class="fas fa-question"></i></span>
            <span class="hidden-xs-down">
                   Questionnaire
                </span>
          </router-link>

          <router-link :to="`/account/user/${id}/investor-list`" :class="[menu === 'investor-list' ? 'active' : '', 'list-group-item']" v-tooltip="'Investor List'"><span class="hidden-sm-up"><i class="fas fa-users"></i></span>
            <span class="hidden-xs-down">
                   Investor List
                </span>
          </router-link>


          <router-link :to="`/account/user/${id}/documents`" :class="[menu === 'documents' ? 'active' : '', 'list-group-item']" v-tooltip="'Documents'"><span class="hidden-sm-up"><i class="fas fa-file"></i></span>
            <span class="hidden-xs-down">
                   Documents
                </span>
          </router-link>

          <router-link :to="`/account/user/${id}/investors`" :class="[menu === 'investors' ? 'active' : '', 'list-group-item']" v-tooltip="'Investors'"><span class="hidden-sm-up"><i class="fas fa-users"></i></span>
            <span class="hidden-xs-down">
                   Assigned Investors
                </span>
          </router-link>

          <router-link :to="`/account/users/general-partners/${id}/weightings`" :class="[menu === 'weightings' ? 'active' : '', 'list-group-item']" v-tooltip="'Weightings'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                   Weightings
                </span>
          </router-link>


          <router-link :to="`/account/users/general-partners/${id}/sales-pipeline`" :class="[menu === 'sales-pipeline' ? 'active' : '', 'list-group-item']" v-tooltip="'Sales Pipeline'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                   Sales History
                </span>
          </router-link>

          <router-link :to="`/account/users/general-partners/${id}/login-log`" :class="[menu === 'login-log' ? 'active' : '', 'list-group-item']" v-tooltip="'Login Log'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                  Login Log
                </span>
          </router-link>

          <router-link :to="'/ps/'+id+'/pdf'" target="_blank" :class="[menu === 'presentation' ? 'active' : '', 'list-group-item']" v-tooltip="'Presentation'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                  Presentation
                </span>
          </router-link>

          <router-link :to="'/ps2/'+id+'/pdf'" target="_blank" :class="[menu === 'presentation' ? 'active' : '', 'list-group-item']" v-tooltip="'Presentation'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                  Presentation V2
                </span>
          </router-link>

          <router-link :to="'/account/users/general-partners/'+id+'/fact-sheet'" target="_blank" :class="[menu === 'fact-sheet' ? 'active' : '', 'list-group-item']" v-tooltip="'Fact Sheet'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                  Fact Sheet
                </span>
          </router-link>

          <router-link :to="'/account/users/general-partners/'+id+'/fact-sheet-v2'" target="_blank" :class="[menu === 'presentation' ? 'active' : '', 'list-group-item']" v-tooltip="'Presentation'"><span class="hidden-sm-up"><i class="fas fa-scale-unbalanced-flip"></i></span>
            <span class="hidden-xs-down">
                   Fact Sheet V2
                </span>
          </router-link>

          <!--    <router-link v-if="user.investors.length && user.profile.is_confirmed==1" :to="`/account/users/general-partners/${user.id}/campaign`" class="btn btn-info btn-sm">Campaign</router-link>-->
          <!--  <button v-if="user.investors.length && user.profile.is_confirmed==1" class="btn btn-info btn-sm" @click.prevent="showMessage(user.id)" v-tooltip="'Message preview'"><i class="fas fa-envelope"></i></button> -->
          <!--   <router-link v-if="user.investors.length" :to="`/account/users/general-partners/${user.id}/investors`" class="btn btn-inverse btn-sm" v-tooltip="'Investor List'">Investor List</router-link>-->


           <!--
            <router-link :to="`/account/user/${id}/contact`" :class="[menu === 'contact' ? 'active' : '', 'list-group-item']" v-tooltip="trans('user.contact')"><span class="hidden-sm-up"><i class="fas fa-phone"></i></span>
               <span class="hidden-xs-down">
                   {{trans('user.contact')}}
               </span>
             </router-link>
             <router-link :to="`/user/${id}/social`" :class="[menu === 'social' ? 'active' : '', 'list-group-item']" v-tooltip="trans('user.social')"><span class="hidden-sm-up"><i class="fas fa-share-alt"></i></span>
                 <span class="hidden-xs-down">
                     {{trans('user.social')}}
                 </span>
             </router-link>-->
            <router-link v-if="id != getAuthUser('id')" :to="`/account/users/general-partners/${id}/password`" :class="[menu === 'password' ? 'active' : '', 'list-group-item']" v-tooltip="trans('user.reset_password')"><span class="hidden-sm-up"><i class="fas fa-key"></i></span>
                <span class="hidden-xs-down">
                    {{trans('user.reset_password')}}
                </span>
            </router-link>
          <!--  <router-link v-if="getConfig('email_template')" :to="`/user/${id}/email`" :class="[menu === 'email' ? 'active' : '', 'list-group-item']" v-tooltip="trans('user.email')"><span class="hidden-sm-up"><i class="fas fa-envelope"></i></span>
                <span class="hidden-xs-down">
                    {{trans('user.email')}}
                </span>
            </router-link> -->
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            menu: {
                default: ''
            },
            id: {
                required: true
            }
        },
        mounted(){
        },
        methods:{
            getAuthUser(name){
                return helper.getAuthUser(name);
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>
